// extracted by mini-css-extract-plugin
module.exports = {"root":"sponsors_root__c_SvE","entry":"sponsors_entry__L9Kqv"};